export default function renderChildrenOrFallback(useTest, mapProps = (props) => props) {
    return function ChildrenOrFallback({ children = null, fallback = null, ...props }) {
        return (useTest(mapProps(props)) ? children : fallback);
    };
}
//# sourceMappingURL=renderChildrenOrFallback.js.map